import {MvsCrudService} from "../../../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnInit} from '@angular/core';
import {TicketTypeObjectBaseComponent} from "../ticket-type-object-base.component";
import {ActivatedRoute} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {TicketTypeService} from "../../../../../../service/api/ticket-type.service";
import {TicketTypeActionService} from "../../../../../../service/api/ticket-type-action.service";
import {MvsCoreService} from "../../../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../../../../core/shared/object/service/observer.service";

@Component({
    selector: 'ticket-type-object-component-side',
    templateUrl: 'ticket-type-object-side.component.html',
    styleUrls: ['ticket-type-object-side.component.scss'],
    standalone: false
})
export class TicketTypeObjectSideComponent extends TicketTypeObjectBaseComponent implements OnInit {

    ticketTypeNotificationTypeService: MvsCrudService;
    ticketTypeObjectTypeService: MvsCrudService;
    ticketTypeObjectRoleService: MvsCrudService;
    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService,
        protected ticketTypeService: TicketTypeService,
        protected ticketTypeActionService: TicketTypeActionService) {
        super(route, coreService, messageService, confirmationService, observerService, ticketTypeService, ticketTypeActionService);
    }

    /**
     * On Object Change. When object is retrieved
     */
    ngOnInit() {
        super.ngOnInit();



        this.ticketTypeNotificationTypeService = this.coreService.getCrudService("tm.TicketTypeNotificationType");
        this.ticketTypeObjectTypeService = this.coreService.getCrudService("tm.TicketTypeObjectType");
        this.ticketTypeObjectRoleService = this.coreService.getCrudService("tm.TicketTypeObjectRole");
    }

    /**
     * load and initialize sidebar navigations
     */
    loadSideBarMenuItems() {
        this.navigationItems = [
            {
                label: 'tm.TicketType',
                action: 'tm.TicketType',
                icon: 'fa-regular fa-typewriter text-xl',
                tooltip: 'Ticket Type',
                toggleable: false,
                default: true
            },
            {
                label: 'tm.TicketTypeAction',
                action: 'tm.TicketTypeAction',
                icon: 'fa-solid fa-hand-point-right text-xl',
                tooltip: 'Ticket Type Action',
                toggleable: false,
                default: false
            },
            {
                label: 'tm.TicketTypeObjectRole',
                action: 'tm.TicketTypeObjectRole',
                icon: 'fa-solid fa-user-tag text-xl',
                tooltip: 'Ticket Type Object Role',
                toggleable: false,
                default: false
            },
            {
                label: 'tm.TicketTypeObjectType',
                action: 'tm.TicketTypeObjectType',
                icon: 'fa-solid fa-layer-group text-xl',
                tooltip: 'Ticket Type Object Type',
                toggleable: false,
                default: false
            },
            {
                label: 'tm.TicketTypeNotificationType',
                action: 'tm.TicketTypeNotificationType',
                icon: 'fa-regular fa-bell text-xl',
                tooltip: 'Ticket Type Notification Type',
                toggleable: false,
                default: false
            },
            {
                label: 'tm.TicketTypeCompleteStatus',
                action: 'tm.TicketTypeCompleteStatus',
                icon: 'fa-solid fa-check-circle text-xl',
                tooltip: 'Ticket Type Completion Status',
                toggleable: false,
                default: false
            },
            {
                label: 'tm.TicketTypeField',
                action: 'tm.TicketTypeField',
                icon: 'fa-solid fa-list-alt text-xl',
                tooltip: 'Ticket Type Field',
                toggleable: false,
                default: false
            }
        ];

    }

}
